import axios from 'axios';
import analytics from 'shared/utility/analytics';

export const getToolSettings = async setBroken => {
  const response = await axios.get('/zelfreflectie/tool-settings').catch(() => setBroken(true));
  const { uaCode } = response.data;
  analytics.init('G-9D17CQYWZM', uaCode);
  return response?.data;
};

export const getInterestRates = async (nhg, ltv, setBroken, setData) => {
  const response = await axios({
    url: '/zelfreflectie/calculate/self-reflection',
    method: 'post',
    data: { nhg, ltv },
  }).catch(() => setBroken(true));

  const data = Object.keys(response.data).length === 0 ? null : response.data;

  setData(data);
};

